import type { Settings as LayoutSettings } from '@ant-design/pro-components';

export type AppThemeMode = 'light' | 'light-tech' | 'dark-tech';

const THEME_STORAGE_KEY = 'qn-theme-mode';

export function getStoredThemeMode(): AppThemeMode {
  const v = localStorage.getItem(THEME_STORAGE_KEY);
  // 兼容：历史版本可能存的是 `light`（“浅色默认”）
  // 但当前不再提供该皮肤，所以自动降级到 `light-tech`，避免用户仍看到“浅色默认”效果
  if (v === 'dark-tech') return 'dark-tech';
  if (v === 'light-tech') return 'light-tech';
  if (v === 'light') return 'light-tech';
  return 'light-tech';
}

export function setStoredThemeMode(mode: AppThemeMode) {
  localStorage.setItem(THEME_STORAGE_KEY, mode);
}

export function applyThemeToDom(mode: AppThemeMode) {
  document.documentElement.setAttribute('data-theme', mode);
}

export function getThemeSettings(mode: AppThemeMode): Partial<LayoutSettings> {
  if (mode === 'light') {
    return {
      navTheme: 'light',
      colorPrimary: '#1677ff',
      token: {
        colorPrimary: '#1677ff',
      },
    };
  }

  if (mode === 'light-tech') {
    return {
      navTheme: 'light',
      colorPrimary: '#6366F1',
      token: {
        // 主色体系
        colorPrimary: '#6366F1',
        colorPrimaryHover: '#4F46E5',
        colorPrimaryActive: '#4338CA',

        // 背景体系
        colorBgLayout: '#F5F7FA',
        colorBgContainer: '#FFFFFF',
        colorBgElevated: '#FFFFFF',

        // 边框体系
        colorBorder: '#E5E7EB',
        colorBorderSecondary: '#F1F5F9',

        // 文字颜色
        colorText: '#111827',
        colorTextSecondary: '#4B5563',
        colorTextTertiary: '#9CA3AF',
        colorTextQuaternary: '#D1D5DB',

        // 圆角
        borderRadius: 12,

        // 阴影（更贴近现代 SaaS）
        boxShadowSecondary: '0 1px 2px rgba(0,0,0,0.05)',
        boxShadow: '0 10px 20px rgba(0,0,0,0.12)',
      },
    };
  }

  // 深色科技
  return {
    navTheme: 'realDark',
    colorPrimary: '#6366F1',
    token: {
      colorPrimary: '#6366F1',
      colorPrimaryHover: '#4F46E5',
      colorPrimaryActive: '#4338CA',
      colorBgLayout: '#0F172A',
      colorBgContainer: '#1E293B',
      colorBorderSecondary: 'rgba(148, 163, 184, 0.22)',
      colorText: 'rgba(226, 232, 240, 0.92)',
      colorTextSecondary: 'rgba(226, 232, 240, 0.66)',
      colorTextTertiary: 'rgba(226, 232, 240, 0.46)',
      borderRadius: 12,
    },
  };
}

